<template>
  <div class="review-action flex-col">
    <template v-if="bidder.supplierId">
      <div class="bidder-review-header">
        <a-list-item class="bidder-review-header__supplier">
          <a-list-item-meta>
            <template v-slot:title>
              <div class="supplier-name m-r-10">
                {{ bidder.supplierName }}
              </div>
            </template>
          </a-list-item-meta>
          <template slot="actions">
            <a-radio-group
              v-if="!showScore"
              v-model="allPass"
              :options="allPassOptions"
              :disabled="readOnly"
              @change="changeAllPass"
            />
          </template>
          <!--<div v-if="showScore">总分：{{ reviewWay.scoreSum || 0 }}</div>-->
          <div v-if="showDetail">
            <span class="text-danger">{{ totalScore || 0 }}</span>
            分
          </div>
        </a-list-item>
      </div>

      <div class="p-r-24 p-l-24">
        <a-divider />
      </div>

      <el-scrollbar ref="reviewScroll" class="bidder-review-body flex-1">
        <online-review-quote
          v-if="isQuoteReview"
          ref="reviewQuote"
          :review-id="reviewId"
          :order-id="orderId"
          :bidder="bidder"
          :offer-unit="offerUnit"
          :purchase-type="purchaseType"
          :quote-review-opened="quoteReviewOpened"
          :offer-require-tax="offerRequireTax"
        />
        <template v-if="showScoreList">
          <div
            v-for="item in bidderScore"
            :key="item.wayItemId"
            class="review-point"
          >
            <div class="review-point__title m-b-10">
              <a-popover
                v-if="showPopover(item.itemName, showScore ? 5 : 16)"
                :content="item.itemName"
                placement="right"
              >
                <div class="text-bold text-ellipsis">
                  {{ item.orderNum }}.{{ item.itemName }}
                </div>
              </a-popover>
              <div v-else class="text-bold text-ellipsis">
                {{ item.orderNum }}.{{ item.itemName }}
              </div>
              <template v-if="showDetail">
                <div v-if="showScore" class="price-score p-r-24">
                  <span class="m-r-8 ">
                    <span class="text-danger">{{ item.score }}</span>
                    分
                  </span>
                  <span>{{ item.remark }}</span>
                </div>
                <div v-else>{{ Number(item.score) ? '通过' : '不通过' }}</div>
              </template>
              <template v-else>
                <div v-if="showScore" class="price-score p-r-24">
                  <a-input-number
                    v-model="item.score"
                    :disabled="readOnly"
                    class="m-r-10"
                    style="width: 120px"
                    :placeholder="`${item.minScore}-${item.maxScore}分`"
                    :controls="false"
                    :precision="2"
                    :min="Number(item.minScore)"
                    :max="Number(item.maxScore)"
                    @input="changeScoreInput(item)"
                  />
                  <a-input
                    v-model="item.remark"
                    placeholder="打分备注（非必填）"
                    :max-length="50"
                    :disabled="readOnly"
                  />
                </div>
                <a-radio-group
                  v-else
                  v-model="item.score"
                  :options="passOptions"
                  :disabled="readOnly"
                  class="m-r-16"
                  @change="changePointPass"
                />
              </template>
            </div>
            <div class="p-r-24">
              <a-input
                v-if="!item.score && !showScore"
                v-model="item.remark"
                placeholder="不通过备注（非必填）"
                :max-length="50"
                :disabled="readOnly"
              />
            </div>

            <row-ellipsis
              :content="item.itemStandard"
              :content-style="{ color: '#999' }"
              class="p-r-24"
            />
          </div>
        </template>
      </el-scrollbar>
    </template>

    <div v-else class="bidder-review-wrap">
      <div class="bidder-review-wrap-default">暂无投标单位</div>
    </div>
  </div>
</template>

<script>
import RowEllipsis from '@/components/online-review/RowEllipsis.vue'
import OnlineReviewQuote from '@/components/online-review/review/OnlineReviewQuote.vue'
import { getPurchaseReviewSupplierScoreDetailApi } from '@/api/procure/purchase-review'
import {
  onlineReviewMethodDict,
  onlineReviewTypeDict
} from '@/dictionary/project/online-review'
import { currencyTypeDict, purchaseTypeDict } from '@/dictionary/project/common'
import Decimal from 'decimal.js'

/**
 * @description 询比评审大厅中的评审操作区域
 */
export default {
  name: 'InquiryReviewAction',

  components: { RowEllipsis, OnlineReviewQuote },

  props: {
    reviewId: {
      type: [String, Number],
      default: ''
    },

    orderId: {
      type: [String, Number],
      default: ''
    },

    bidder: {
      type: Object,
      default: () => {}
    },

    reviewWay: {
      type: Object,
      default: () => {}
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    reviewer: {
      type: Object,
      default: () => {}
    },

    offerUnit: {
      type: String,
      default: currencyTypeDict.YUAN.label
    },

    showDetail: {
      type: Boolean,
      default: false
    },

    purchaseType: {
      type: [Number, String],
      default: purchaseTypeDict.INQUIRY.value
    },

    // 是否开启打分
    quoteReviewOpened: {
      type: Boolean,
      default: false
    },

    // 报价是否含税
    offerRequireTax: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      // 是否全部通过
      allPass: '',
      allPassOptions: [
        { label: '全通过', value: 1 },
        { label: '不通过', value: 0 }
      ],
      passOptions: [
        { label: '通过', value: 1 },
        { label: '不通过', value: 0 }
      ],
      // 当前投标人的评分情况
      bidderScore: []
    }
  },

  computed: {
    // 评审点列表
    reviewItemList() {
      return this.reviewWay?.itemInfoList || []
    },

    showScore() {
      return this.reviewWay?.reviewMethod === onlineReviewMethodDict.SCORE.value
    },

    // 是价格分评审
    isQuoteReview() {
      return this.reviewWay.wayType === onlineReviewTypeDict.QUOTATION.value
    },

    totalScore() {
      return this.bidderScore.reduce((acc, cur) => {
        return Decimal.add(acc, Number(cur.score))
      }, 0)
    },

    showScoreList() {
      return (
        (this.isQuoteReview && this.quoteReviewOpened) || !this.isQuoteReview
      )
    }
  },

  watch: {
    bidder: {
      handler(val) {
        console.log('watch bidder', val)
        if (val?.supplierId && this.reviewWay?.wayId) {
          this.getBidderScoreDetail()
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    showPopover(content) {
      return content?.length > 10
    },

    /**
     * 更改全通过或全不通过
     */
    changeAllPass(e) {
      this.bidderScore.forEach(item => {
        item.score = e.target.value
      })
    },

    changeScoreInput(row) {
      const pattern = /^[1-9][0-9]*$/
      if (!pattern.test(row.score) || Number(row.score) > 100) {
        row.score = ''
        this.$message.warning(`评分不能超出${row.minScore} ~ ${row.maxScore}`)
      }
    },

    changePointPass(e) {
      if (e.target.value !== this.allPass) {
        this.allPass = ''
      }
      this.$forceUpdate()
    },

    /**
     * 获取当前投标单位的评审详情
     */
    getBidderScoreDetail() {
      const params = {
        wayId: this.reviewWay.wayId,
        supplierId: this.bidder.supplierId
      }
      if (this.reviewer?.reviewerId) {
        params.reviewerId = this.reviewer.reviewerId
      }
      getPurchaseReviewSupplierScoreDetailApi(this.reviewId, params)
        .then(res => {
          const itemScoreList = res.data?.itemScoreList || []
          this.bidderScore = this.reviewWay.itemInfoList.map(item => {
            const itemScore = itemScoreList.find(
              score => score.wayItemId === item.wayItemId
            )
            if (itemScore?.score) {
              itemScore.score = Number(itemScore.score)
            }
            return {
              ...item,
              ...itemScore
            }
          })
          if (
            this.reviewWay?.reviewMethod === onlineReviewMethodDict.PASS.value
          ) {
            if (this.bidderScore.every(item => item.score)) {
              this.allPass = 1
            } else if (this.bidderScore.every(item => item.score === 0)) {
              this.allPass = 0
            } else {
              this.allPass = ''
            }
          }
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    getBidderScore() {
      return this.bidderScore || []
    }
  }
}
</script>

<style scoped lang="scss">
.review-action {
  overflow: hidden;
}

.bidder-review-wrap {
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  position: relative;

  .bidder-review-wrap-default {
    //height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.bidder-review-header {
  padding-left: 24px;
  padding-top: 24px;

  .bidder-review-header__supplier {
    padding: 0 16px 0 0;
    align-items: stretch;

    ::v-deep .ant-list-item-meta-title {
      margin-bottom: 0;
    }

    ::v-deep .ant-list-item-action {
      margin: 0;

      li {
        padding-right: 0;
      }
    }

    .supplier-name {
      width: 180px;
      color: #333333;
      font-weight: bold;
    }
  }
}

.bidder-review-body {
  position: relative;
  padding-left: 24px;

  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .review-point {
    &:not(:last-child) {
      margin-bottom: 8px;
    }

    .review-point__title {
      width: 100%;
      display: flex;
      align-items: stretch;
      justify-content: space-between;

      .text-btn {
        color: $primary-color;
        cursor: pointer;
      }
    }

    ::v-deep .ant-radio-group {
      flex-shrink: 0;
    }
  }

  // 价格分
  .price-score {
    display: flex;
    flex-shrink: 0;
  }
}
</style>
